import { FC } from 'react';

import { IconProps } from 'react-feather';

const ProbeIcon: FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill={color}
    {...rest}
  >
    <path
      fillRule="evenodd"
      d="M12.496.146a.498.498 0 0 1 .59-.086 7.13 7.13 0 0 1 2.853 2.853.498.498 0 0 1-.085.591l-4.66 4.66a.498.498 0 0 1-.44.139 1.9 1.9 0 0 0-1.267.556l-5.1 5.1a5.999 5.999 0 0 1-2.125 1.389l-1.585.61a.498.498 0 0 1-.644-.644l.612-1.59a6.265 6.265 0 0 1 1.386-2.12l5.101-5.1a1.9 1.9 0 0 0 .557-1.345c0-.132.053-.26.146-.353l4.66-4.66ZM10.638 7.31l4.24-4.24a6.136 6.136 0 0 0-1.949-1.95L8.678 5.374a2.897 2.897 0 0 1-.841 1.835L2.735 12.31a5.266 5.266 0 0 0-1.163 1.78l-.206.536.538-.207a5 5 0 0 0 1.774-1.16l.003-.003 5.101-5.1a2.897 2.897 0 0 1 1.856-.844Z"
      clipRule="evenodd"
    />
  </svg>
);

export default ProbeIcon;
